import { Component, OnInit, SecurityContext } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer} from '@angular/platform-browser';


@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html',
  styleUrls: ['header.component.css']
})
export class HeaderComponent implements OnInit {

  constructor(private router: Router,private sanitizer:DomSanitizer) { }

  ngOnInit(): void {
  }
  cerrar(){
    var urlcierre :string="https://accounts.claveunica.gob.cl/api/v1/accounts/app/logout?https%3A%2F%2Faplicaciones.mop.gob.cl%2FTramitesDCyF";
    var sanitizedValue:string= this.sanitizer.sanitize(SecurityContext.URL,urlcierre);
    window.location.href=sanitizedValue;
    localStorage.clear();
    this.router.navigate(['/inicio']);
   }
  
   inicio(){
    this.router.navigate(['/inicio']);
   }
}
